












import { Component, Mixins } from "vue-property-decorator";
import { TextPresentableObjectDrawerBase } from "./base";
import { default as NamedRectangleCoordinatableObjectDrawer } from "./NamedRectangleCoordinatableObjectDrawer.vue";

@Component({
  components: {
    NamedRectangleCoordinatableObjectDrawer,
  },
})
export default class BarcodeObjectDrawer extends Mixins(TextPresentableObjectDrawerBase) {}
